import {Injectable, Type} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {
    IntegrationAdapterTypeObjectBaseComponent
} from "../../component/object-components/integration-adapter-type-object-base-component/integration-adapter-type-object-base.component";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";

@Injectable({
    providedIn: 'root'
})
export class IntegrationAdapterTypeService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/hc/integrationAdapterTypes')
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        if (mode != MvsCrudModeEnum.create) {
            return IntegrationAdapterTypeObjectBaseComponent
        }
        return null;
    }

}